// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1VXyX","gfeWrapper":"CalendarEvent_gfeWrapper__1uK4H"};